import api from '@/api/itemType'
import { errorHandler } from '../exports/error_management'

import { StorageCache } from '../exports/dataStorage'

const storageKey = 'ams-order-item-key'

const state = {
    item: null,
    items: [],
}

const mutations = {
    set_item(state, payload) {
        state.item = payload
    },
    set_items(state, payload) {
        state.items = payload
    },
}

const actions = {
    create(context, payload) {
        new StorageCache(storageKey).reset()
        return api
            .create(payload)
            .then(results => {
                console.log('createdResults', results)
            })
            .catch(err => {
                errorHandler(err)
            })
    },
    fetchById(context, id) {
        return api
            .fetchById(id)
            .then(
                ({
                    data: {
                        success: { data },
                    },
                }) => {
                    console.log('fetch item', data)
                    context.commit('set_item', data)
                }
            )
            .catch(err => {
                errorHandler(err)
            })
    },

    async fetchAll(context) {
        const storageCache = new StorageCache(storageKey)
        try {
            const { is_valid, value } = storageCache.getArray()
            if (!is_valid) {
                const {
                    data: {
                        success: { data },
                    },
                } = await api.fetchAll()

                storageCache.set(data)
                value.splice(0)
                value.push(...data)
            }
            context.commit('set_items', value)
        } catch (err) {
            errorHandler(err)
        }
    },

    update(context, payload) {
        console.log('update', payload)
        new StorageCache(storageKey).reset()
        return api
            .update(payload.id, payload)
            .then(results => {
                console.log('updateResults', results)
            })
            .catch(err => {
                errorHandler(err)
            })
    },
    delete(context, id) {
        new StorageCache(storageKey).reset()
        return api
            .delete(id)
            .then(() => {
                let index = state.items.findIndex(x => x.id == id)
                context.state.items.splice(index, 1)
            })
            .catch(err => {
                errorHandler(err)
            })
    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
